import * as RadixTooltip from '@radix-ui/react-tooltip';
import type React from 'react';

import { TooltipArrow, TooltipContent, TooltipTrigger } from './wrapper';

interface TooltipProps {
  children: React.ReactNode;
  content?: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  delayDuration?: number;
  whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap';
  /** @deprecated Use `content` instead */
  tooltip?: string;
  /** @deprecated Use `whiteSpace` instead */
  $whiteSpace?: 'pre' | 'pre-wrap';
}

const Tooltip = ({
  children,
  content,
  side = 'top',
  align = 'center',
  sideOffset = 4,
  delayDuration = 0,
  whiteSpace,
  tooltip,
  $whiteSpace,
}: TooltipProps) => {
  const tooltipContent = content ?? tooltip;
  const resolvedWhiteSpace = whiteSpace ?? $whiteSpace ?? 'nowrap';

  if (!tooltipContent) {
    return <>{children}</>;
  }

  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>
          <TooltipTrigger>{children}</TooltipTrigger>
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <TooltipContent
            side={side}
            align={align}
            sideOffset={sideOffset}
            $whiteSpace={resolvedWhiteSpace}
          >
            {tooltipContent}
            <TooltipArrow />
          </TooltipContent>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
